!function () {
  "use strict";

  if (customElements.get("video-hover-play")) return;

  customElements.define("video-hover-play", class extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.poster = this.querySelector("[data-hover-poster]");
      this.videoTemplate = this.querySelector("template[data-hover-video]");
      this.videoContainer = this.querySelector("[data-hover-video-container]");
      this.loaded = false;
      this.playing = false;
    }

    connectedCallback() {
      /* Desktop only — no hover on touch devices */
      if ("ontouchstart" in window && window.innerWidth < 750) return;

      this.addEventListener("mouseenter", this.onEnter.bind(this));
      this.addEventListener("mouseleave", this.onLeave.bind(this));
    }

    onEnter() {
      if (!this.loaded) {
        this.loadVideo();
      }

      if (this.video) {
        this.video.currentTime = 0;
        var playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise.then(() => {
            this.playing = true;
            this.classList.add("is-hovering");
          }).catch(() => {
            /* Autoplay blocked — keep poster visible */
            this.playing = false;
          });
        }
      }
    }

    onLeave() {
      if (this.video && this.playing) {
        this.video.pause();
        this.playing = false;
      }
      this.classList.remove("is-hovering");
    }

    loadVideo() {
      if (!this.videoTemplate || !this.videoContainer) return;

      this.videoContainer.innerHTML = this.videoTemplate.innerHTML;
      this.video = this.videoContainer.querySelector("video");

      if (this.video) {
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.loop = true;
        this.video.setAttribute("playsinline", "");
        this.video.setAttribute("muted", "");
        this.loaded = true;
      }
    }

    disconnectedCallback() {
      if (this.video) {
        this.video.pause();
        this.video.src = "";
        this.video.load();
      }
    }
  });
}();
